import { Directive } from '@angular/core';
import { OpportunityFacade } from '../+state/opportunity-state-base.component';

@Directive()
export abstract class OpportunityDetailBaseComponent extends OpportunityFacade {
  public text = 'OpportunityDetail';

  constructor() {
    super();
  }
}
